/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Email_Newsletters_To_AudioInputs */

const en_email_newsletters_to_audio = /** @type {(inputs: Email_Newsletters_To_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn newsletters into audio`)
};

const es_email_newsletters_to_audio = /** @type {(inputs: Email_Newsletters_To_AudioInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte boletines en audio`)
};

/**
* | output |
* | --- |
* | "Turn newsletters into audio" |
*
* @param {Email_Newsletters_To_AudioInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const email_newsletters_to_audio = /** @type {((inputs?: Email_Newsletters_To_AudioInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Newsletters_To_AudioInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_email_newsletters_to_audio(inputs)
	return en_email_newsletters_to_audio(inputs)
});